import React, { HTMLAttributes } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";

import { Hooks } from "@xt/xtbase";
const { useTranslation } = Hooks;
// import store from "store";

import styles from "./index.module.less";

interface Props extends HTMLAttributes<HTMLDivElement> {
  attr?: any;
}

const Main: React.FC<Props> = ({ className }) => {
  const t = useTranslation();
  // const {isLogin} = store.user;

  const partnerLinks = [
    {href: "https://www.btok.com/", url: require("@/assets/images/aboutus/footer/btok.png").default},
    {href: "http://bananatok.io/", url: require("@/assets/images/aboutus/footer/bananatok.png").default},
    {href: "http://wxycon.com/#/", url: require("@/assets/images/aboutus/footer/wxygroup.png").default},
    {href: "https://www.coingecko.com/", url: require("@/assets/images/aboutus/footer/coingecko.png").default},
    {href: "https://cobak.co.kr/", url: require("@/assets/images/aboutus/footer/cobak.png").default},
    {href: "http://www.coinreaders.com/", url: require("@/assets/images/aboutus/footer/coinreaders.png").default},
    {href: "https://aliansikoin.com/", url: require("@/assets/images/aboutus/footer/aliansikoin.png").default},
    {href: "https://www.feixiaohao.com/", url: require("@/assets/images/aboutus/footer/small.png").default},
    {href: "https://www.aicoin.com/", url: require("@/assets/images/aboutus/footer/alcoin.png").default},
    {href: "https://xangle.io/", url: require("@/assets/images/aboutus/footer/xangle.png").default},
    {href: "https://coin360.com/", url: require("@/assets/images/aboutus/footer/coin360.png").default},
    {href: "https://www.coinghost.com/", url: require("@/assets/images/aboutus/footer/coinghost.png").default},
    {href: "https://www.coinhills.com/", url: require("@/assets/images/aboutus/footer/coinhills.png").default},
    {href: "https://www.cryptowisser.com/exchange/xt-com/", url: require("@/assets/images/aboutus/footer/cryptowisser.png").default},
    {href: "https://banxa.com/", url: require("@/assets/images/aboutus/footer/banxa.png").default},
    {href: "https://hacken.io/", url: require("@/assets/images/aboutus/footer/hacken.png").default},
    {href: "https://www.intotheblock.com/", url: require("@/assets/images/aboutus/footer/intotheblock.png").default},
    {href: "https://www.jinse.com/", url: require("@/assets/images/aboutus/footer/yellow.png").default},
    {href: "https://mercuryo.io/", url: require("@/assets/images/aboutus/footer/mercuryo.png").default},
    {href: "https://gotbit.io/", url: require("@/assets/images/aboutus/footer/gotbit.png").default},
    {href: "https://cafe.naver.com/worldchangingbitcoin/", url: require("@/assets/images/aboutus/footer/hanwen.png").default},
    {href: "https://coinedition.com/", url: require("@/assets/images/aboutus/footer/edition.png").default},
    {href: "https://www.tokenpost.kr/", url: require("@/assets/images/aboutus/footer/tokenpost.png").default},
    {href: "https://advcash.com/", url: require("@/assets/images/aboutus/footer/advcash.png").default},
    {href: "https://www.simplex.com/", url: require("@/assets/images/aboutus/footer/simple.png").default},
    {href: "https://en.bitpush.news/", url: require("@/assets/images/aboutus/footer/bitpush.png").default},
    {href: "https://bittab.io/?from=xtcom", url: require("@/assets/images/aboutus/footer/bittab.png").default},
    {href: "https://bitcoin-trading.io/exchanges/xt-crypto-exchange-review", url: require("@/assets/images/aboutus/footer/bitcoin-trading.png").default},
    {href: "https://www.chiliz.com/", url: require("@/assets/images/aboutus/footer/chiliz1.png").default},
    {href: "https://www.koinly.io/", url: require("@/assets/images/aboutus/footer/koinly-logos-idMfNhKNPz\ 1.png").default},
    {href: "https://www.traderx.vip/en", url: require("@/assets/images/aboutus/footer/TraderX.png").default},
    {href: "https://walletinvestor.com/", url: require("@/assets/images/aboutus/footer/walletInvestor.png").default},
    {href: "https://investorbites.com/", url: require("@/assets/images/aboutus/footer/inverstor.png")},
  ]

  const iconList = () => {
    return (
      partnerLinks &&
      partnerLinks.map((item, index) => (
        <a href={item?.href} target="_blank" key={index}>
          <span style={{ backgroundImage: `url(${item?.url})` }}></span>
        </a>
      ))
    );
  }

  return (
    <div className={cx(styles.partners, className)}>
      <h3 className={cx(styles.cumTit, className)}>{ t("cmpt.partner") }</h3>
      <div className={cx(styles.listContennt, className)}>
        <div className={cx(styles.listBox, className)}>
          {iconList()}
        </div>
      </div>
    </div>
  );
};

export default observer(Main);
// export default Main;
